import { twMerge } from "tailwind-merge";
import { formatUnits } from "viem";
import { useAccount, useBalance, useChainId } from "wagmi";

import { Icon } from "shared/ui/icon";
import { NumericInput } from "shared/ui/numeric-input";
import { formatCurrency } from "shared/web3/utils";

type Props = {
  className?: string;
  disabled?: boolean;
  onChange: (value: string) => void;
  onMaxClick: (amount: string) => void;
  value: string;
};

export const Input = (props: Props) => {
  const chainId = useChainId();
  const { address } = useAccount();
  const { className, disabled, onMaxClick, onChange, value } = props;

  const balanceQuery = useBalance({ chainId, address });

  const formattedBalance = balanceQuery.data?.value
    ? formatUnits(balanceQuery.data.value, balanceQuery.data.decimals)
    : undefined;

  return (
    <div
      className={twMerge("flex flex-col", disabled && "opacity-40", className)}
    >
      <label className={twMerge("text-pickledBluewood mb-1.5 block text-xs")}>
        Amount GNET
      </label>
      <div className="relative flex flex-col">
        <NumericInput
          className="border-dawnPink2 bg-desertStorm font-ptm rounded-lg border px-4 py-3 pr-[120px] text-2xl outline-hidden"
          decimalScale={18}
          disabled={disabled}
          onValueChange={({ value }) => {
            onChange(value);
          }}
          placeholder="0"
          value={value}
        />

        <div className="text-pickledBluewood absolute top-1/2 right-3 flex max-w-[100px] -translate-y-1/2 flex-col justify-end text-xs">
          <div className="text-right">
            Available:{" "}
            <span
              className={twMerge(
                "from-sunriseOrange to-fadedOrange bg-linear-to-tr bg-clip-text text-transparent"
              )}
            >
              {formatCurrency(formattedBalance ?? "0")}
            </span>
          </div>
          <div className="flex items-center justify-end gap-x-1">
            <button
              className="border-iron text-santaGrey flex h-[18px] w-[36px] cursor-pointer items-center justify-center rounded-sm border text-xs"
              disabled={Boolean(!formattedBalance)}
              onClick={() => formattedBalance && onMaxClick(formattedBalance)}
            >
              MAX
            </button>
            <Icon className="size-4" name="galactica" />
            <span className="text-sm">GNET</span>
          </div>
        </div>
      </div>
    </div>
  );
};
